module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Italic.6d1bf761.woff";